import {InputText} from '@/components/Form/index.mjs'
import FormItemBizProp from '../components/FormItemBizProp.jsx'
import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemOoName, FormItemOoNo} from '../OO/FormChooseOo.jsx'
import Model from './ModelOu.mjs'

export const FormItemOuName = props => (
    <FormItemBizProp
        Model={Model}
        prop="ouName"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export default function FormChooseOu(props) {
    return (
        <FormChooseDesign {...props}>
            <FormItemOoNo />
            <FormItemOoName />
            <FormItemOuName />
        </FormChooseDesign>
    )
}
